import { connect } from 'react-redux';
import { getCurrentUserId } from '../../../publicSession/selectors';
const mapStateToProps = (state, ownProps)=>({
        isCurrentUserOwner: ownProps.folder.owner && getCurrentUserId(state) === ownProps.folder.owner.userId
    });
export default connect(mapStateToProps);

//# sourceMappingURL=FolderCardContent.container.js.map